import React, { useEffect, useState } from 'react';

// const API = 'http://localhost:5000/api/apps';
const API_KEY = process.env.REACT_APP_API_URL


export function AppsIndex() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_KEY}/api/apps`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch apps');
        return res.json();
      })
      .then(data => {
        setApps(data?.apps);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Toggle approval status
  const toggleApproval = async (app) => {
    const updatedStatus = !app.is_approved;

    try {
      const res = await fetch(`${API_KEY}/api/apps/${app._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ is_approved: updatedStatus }),
      });
      if (!res.ok) throw new Error('Failed to update approval');

      const updatedApp = await res.json();

      setApps(apps.map(a => (a._id === updatedApp._id ? updatedApp : a)));
    } catch (err) {
      alert(err.message);
    }
  };

  // Delete app
  const deleteApp = async (id) => {
    if (!window.confirm('Are you sure you want to delete this app?')) return;

    try {
      const res = await fetch(`${API_KEY}/${id}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Failed to delete app');

      setApps(apps.filter(app => app._id !== id));
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div className="container py-5">Loading apps...</div>;
  if (error) return <div className="container py-5 text-danger">Error: {error}</div>;

  return (
    <div className="container py-5" style={{ maxWidth: "900px" }}>
      <h2 className="mb-4">All Apps</h2>
      {apps.length === 0 ? (
        <p>No apps found.</p>
      ) : (
        <div className="list-group">
          {apps.map((app) => (
            <div
              key={app._id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <h5 className="mb-1">{app.name}</h5>
                <p className="mb-1">{app.description || 'No description'}</p>
                <a href={app.link} target="_blank" rel="noopener noreferrer">
                  Visit App
                </a>
                <p className="mb-0">
                  <small>Category: {app.category_id?.name || 'Unknown'}</small>
                </p>
              </div>

              <div className="d-flex flex-column align-items-end">
                <button
                  className={`btn mb-2 ${app.is_approved ? 'btn-success' : 'btn-outline-secondary'}`}
                  onClick={() => toggleApproval(app)}
                >
                  {app.is_approved ? 'Approved' : 'Approve'}
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() => deleteApp(app._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
